// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3_eM7","imageUploader":"EGiftCard_imageUploader__173sp"};